export function getImageMimeType(path: string): string {
  return "image/" + path.split(".").pop();
}
